import { AspectRatio, Box, BoxProps, rem } from '@mantine/core'

import { CardItem } from '..'
import { Tags } from '../tags'
import useStyles from './index.styles'

export type DoctorAvatarProps = {
  doctor: CardItem
  ratio?: number
} & BoxProps

const DoctorAvatar = ({
  doctor,
  ratio = 1,
  className,
  classNames,
  styles,
  ...boxProps
}: DoctorAvatarProps) => {
  const { classes, cx } = useStyles(undefined, {
    name: 'DoctorAvatar',
    classNames,
    styles,
  })
  const { name, avatar, validTelemedicine, validOutpatient } = doctor
  return (
    <Box className={cx(classes.avatar, className)} {...boxProps}>
      <AspectRatio
        ratio={ratio}
        sx={{
          borderRadius: 'inherit',
        }}
      >
        <Box
          sx={{
            alignItems: 'flex-start !important',
            borderRadius: 'inherit',
          }}
        >
          <img
            src={avatar}
            loading="lazy"
            alt={name}
            style={{
              width: '100%',
              maxHeight: 'none',
            }}
          />
        </Box>
      </AspectRatio>
      <Tags
        hasOutpatient={validOutpatient}
        hasTelemedicine={validTelemedicine}
        sx={{
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          padding: rem(8),
        }}
      />
    </Box>
  )
}

export { DoctorAvatar }
